import { render, staticRenderFns } from "./common_new.vue?vue&type=template&id=4f2567fa&scoped=true"
import script from "./common_new.vue?vue&type=script&lang=js"
export * from "./common_new.vue?vue&type=script&lang=js"
import style0 from "./common_new.vue?vue&type=style&index=0&id=4f2567fa&prod&lang=less&scoped=true"
import style1 from "./common_new.vue?vue&type=style&index=1&id=4f2567fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2567fa",
  null
  
)

export default component.exports